import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { BrandBlockView } from './BrandBlockView';

export const Brand = Node.create({
    name: 'brand',

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {
            isPopular: {
                default: false,
            },
            isLatest: {
                default: true,
            },
            brandCount: {
                default: 10,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
                getAttrs: (dom) => {
                    return {
                        isPopular: dom.getAttribute('data-isPopular') === 'true',
                        isLatest: dom.getAttribute('data-isLatest') === 'true',
                        brandCount: dom.getAttribute('data-brandCount') || 10,
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const {
            isPopular,
            isLatest,
            brandCount,
        } = HTMLAttributes;

        return [
            'div',
            {
                'data-type': 'brand',
                'data-isPopular': isPopular,
                'data-isLatest': isLatest,
                'data-brandCount': brandCount,
                class: 'brand-block',
            },
            'Brand Block'
        ];
    },

    addCommands() {
        return {
            setBrand:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {
                                isPopular: options?.isPopular || false,
                                isLatest: options?.isLatest || true,
                                brandCount: options?.brandCount || 10,
                            },
                        });
                    },
            updateBrand:
                (options) =>
                    ({ commands }) => {
                        return commands.updateAttributes(this.name, options);
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(BrandBlockView);
    },
});